import { render, staticRenderFns } from "./Frontpage.vue?vue&type=template&id=c5bb467e&"
import script from "./Frontpage.vue?vue&type=script&lang=ts&"
export * from "./Frontpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports